<app-lms-modal-frame [title]="'Menu Administration'" [pageHeadWidth]="600">
  <div modal-body class="form-container container-fluid">
    <form [formGroup]="menuForm">

    <mdb-tabs  class="m-1">
      <mdb-tab title="Menu Details">
        <div class="center-screen">
          <table class="table table-striped table-light table-hover  shadow-2-strong m-1 p-1 shadow-inner table-sm"
            style="width:770px; overflow-y: auto;">
            <caption>Menu Details</caption>
            <tbody class="field-4column-label">
              <tr>
                <td>Menu Name</td>
                <td>
                  <input formControlName="menu" [(ngModel)]="menuModel.menu" required>
                  <div *ngIf="menuForm.controls!.menu?.errors?.required && submitted" class="error-label">
                    Menu name is required.
                  </div>
                </td>
              </tr>
              <tr>
                <td>Component</td>
                <td>
                  <input formControlName="menu_component" [(ngModel)]="menuModel.component" required>
                  <div
                    *ngIf="menuForm.controls!.menu_component?.errors?.required && submitted && isComponentRequired == true"
                    class="error-label">
                    Component is required.
                  </div>

                </td>
              </tr>
              <tr>
                <td>Submenus</td>
                <td>
                  <input type="checkbox" class="form-check-input" (change)="hasSubmenuOnChangeEvent($event)"
                    [checked]="menuModel.hasSubmenu" [(ngModel)]="menuModel.hasSubmenu" formControlName="hasSubmenu">
                </td>
              </tr>
              <tr>
                <td><label for="selectedRole">Role</label></td>
                <td>
                  <mdb-select class="select table-control" style="width: 99%" formControlName="selectedJobTitles" multiple required>
                    <mdb-option *ngFor="let title of jobTitles" [value]="title">{{title.jobTitle}}</mdb-option>
                  </mdb-select>

                  <div *ngIf="menuForm.controls!.selectedRole?.errors?.required && submitted" class="error-label">
                    Job title is required.
                  </div>
                </td>
              </tr>
              <tr>
                <td>Trigger</td>
                <td>
                  <input formControlName="trigger" [(ngModel)]="menuModel.trigger" required>
                  <div *ngIf="menuForm.controls!.trigger?.errors?.required && submitted && isTriggerRequired == true"
                    class="error-label">
                    Trigger is required.
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mdb-tab>

      <mdb-tab title="Sub Menus">
        <div class="d-flex p-3 justify-content-end">
          <button class="btn btn-primary btn-sm btn-add-row" mdbRipple type="button" (click)="addRow()">Add Sub
            menu</button>
        </div>
        <div class="center-screen p-2" style="min-height: 200px !important; max-height: 350px">
          <table class="shadow-2-strong rounded-1 p-1 m-1 w-100">
            <thead>
              <tr class="table-center-header">
                <th *ngFor="let col of columnsSchema">{{ col.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of dataSource; let even = even" [ngClass]="{gray: even}">
                <td *ngFor="let col of columnsSchema">
                  <div [ngSwitch]="col.type" *ngIf="!element.isEdit">
                    <div class="btn-edit" *ngSwitchCase="'isEdit'">
                      <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple type="button" (click)="editSubmenu(element)">
                        <i class="fas fa-xs fa-fw fa-pencil"></i>
                      </button>
                      <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple type="button" (click)="removeRow(element)">
                        <i class="fas fa-xs fa-fw fa-trash-can"></i>
                      </button>
                    </div>
                    <span *ngSwitchDefault>{{element[col.key]}}</span>
                  </div>
                  <div [ngSwitch]="col.type" *ngIf="element.isEdit">
                    <div *ngSwitchCase="'isEdit'">
                      <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple type="button" (click)="modifyMenu(element)">
                        <i class="fas fa-xs fa-fw fa-floppy-disk"></i>
                      </button>
                    </div>
                    <input *ngSwitchDefault (input)="removeTrailingSpaces(element)" style="width: 95%" [type]="col.type"
                      required [(ngModel)]="element[col.key]" value=" {{element[col.key]}}" [ngModelOptions]="{standalone: true}" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mdb-tab>
    </mdb-tabs>
    </form>
  </div>

  <div modal-actions class="lms-action-bar">
    <button class="btn btn-primary me-2" mdbRipple (click)="close()">Close</button>
    <button class="btn btn-primary" mdbRipple (click)="saveChanges()">Save Changes</button>
  </div>
</app-lms-modal-frame>
